import { queryOptions } from '@tanstack/react-query'
import { getSessionConfig } from 'src/queries/session/config/config.network'

export const sessionConfigQueryKeys = {
  all: () => ['sessionConfig'] as const,
  byLocale: (locale: string | undefined) =>
    [...sessionConfigQueryKeys.all(), locale] as const,
}

export const sessionConfigQueries = {
  byLocale: (locale: string | undefined) =>
    queryOptions({
      queryKey: sessionConfigQueryKeys.byLocale(locale),
      queryFn: () => getSessionConfig(locale!),
      enabled: Boolean(locale),
      /**
       * staleTime/gcTime Infinity — static reference data (department /
       * industry / currency / locale / team-size / referral-source option
       * lists) that only varies by locale, and locale is part of the query
       * key. The legacy Redux flow fetched this once per locale and kept it
       * for the whole browser session (config.reducer state was never reset,
       * even on logout), so never marking a fetched locale stale (staleTime)
       * and never garbage-collecting it once consumers unmount (gcTime)
       * preserves that behavior across the ~9 consumers.
       */
      staleTime: Infinity,
      gcTime: Infinity,
    }),
}
